import { ContactInfo } from 'components/ContactInfo/themes/BGH/ContactInfo';
import stylesHeader from 'components/Header/themes/BGH/stylesHeader.scss';
import styles from './styles.scss';
import { Logo } from 'components/Header/themes/BGH/Logo';
import connect from 'components/Shared/connect';
import { StoresInfo } from 'components/StoreInfo/themes/BGH-RD3/StoresInfo';
import { Search } from 'components/Search/themes/BGH-RD3/search';
import { Basket } from 'components/Basket/themes/BGH/basket';
import MainMenu from 'components/MainMenu';
import cn from 'classnames';
import { Backdrop } from './backdrop';
import { getCartItemQuantity } from 'components/Basket/selector';
import { CountdownAd as CountdownModel } from 'models/CountdownAd';
import { MobileBasket } from 'components/Basket/themes/BGH/mobileBasket';
import { Favourites } from 'components/Favourites/favourites';
import { getChannel, getComponentName } from 'views/ProductPage/selector';
import { isLegacy } from 'utils';
import { isMobile } from 'components/Shared/responsive';
import { TopBar } from 'components/Header/themes/BGH/topBar';
import { NewsletterModal } from 'components/NewsletterModal';
import { useState } from 'react';
import { useWaitForUser } from 'hooks/useWaitForUser';
import { useSelector } from 'react-redux';
import { selectBlackFridayStatus, selectHelpCenterStatus, selectContactSection } from './selector';
import { ContactButton } from '@bygghemmait/blocks';

interface MergedProps {
  countDown?: CountdownModel;
  numberOfFavourites: number;
  quantity: number;
  componentName: string;
  channel: string;
  isMobile: boolean;
  topBarId: string;
}

interface StickyHeaderProps {
  hasFavourites?: boolean;
  hasItemsInBasket?: boolean;
}

export const Header = connect<MergedProps>(state => ({
  channel: getChannel(state),
  componentName: getComponentName(state),
  quantity: getCartItemQuantity(state),
  numberOfFavourites: state.favourites.productIds?.length,
  isMobile: isMobile(state)
}))(({ numberOfFavourites, quantity, componentName, channel, isMobile }: MergedProps) => {
  const legacy = isLegacy({ componentName, channel });
  const hasItemsInBasket = quantity > 0;
  const hasFavourites = numberOfFavourites > 0;

  const [userHasInteracted, setUserHasInteracted] = useState(false);

  useWaitForUser(() => setUserHasInteracted(true));

  const blackFridayIsActive = useSelector(selectBlackFridayStatus);

  return (
    <>
      {isMobile && (
        <>
          <StickyHeader hasFavourites={hasFavourites} hasItemsInBasket={hasItemsInBasket} />
        </>
      )}
      <NewsletterModal userHasInteracted={userHasInteracted} />

      <div className={styles.base}>
        {legacy && <Backdrop />}
        <div
          className={cn(styles.topbarSpace, styles.topBar, {
            [styles.blackFriday]: blackFridayIsActive
          })}
        />
        <div className={cn(styles.menuspace, { [styles.blackFriday]: blackFridayIsActive })} />
        <div className={cn(styles.headerSpace)} />
        <header
          className={cn(stylesHeader.headerStyles, { [stylesHeader.bno]: channel === 'BNO' })}
        >
          <TopBar />
          <div
            className={cn(styles.favourites, styles.topBar, {
              [styles.withBasket]: hasItemsInBasket
            })}
          >
            {hasFavourites && <Favourites />}
          </div>
          <Logo className={styles.logo} />
          <div className={styles.search}>
            <Search />
          </div>
          {hasItemsInBasket ? (
            <WrappedBasket hasItems={hasItemsInBasket} />
          ) : (
            <div className={styles.empty} />
          )}
          <MainMenu className={cn(styles.menu, { [styles.blackFriday]: blackFridayIsActive })} />
        </header>
      </div>
    </>
  );
});

const WrappedBasket = (props: { hasItems: boolean }) => (
  <div className={styles.checkout}>{props.hasItems && <Basket className={styles.basket} />}</div>
);

const StickyHeader = ({ hasFavourites, hasItemsInBasket }: StickyHeaderProps) => {
  const helpCenterStatus = useSelector(selectHelpCenterStatus);
  const contactSection = useSelector(selectContactSection);
  return (
    <div className={styles.stickyHeaderWrapper}>
      <header className={stylesHeader.headerStyles}>
        {hasFavourites ? (
          <div
            className={cn(styles.favourites, styles.topBar, {
              [styles.withBasket]: hasItemsInBasket
            })}
          >
            <Favourites />
          </div>
        ) : (
          <div className={styles.empty} />
        )}
        <div
          className={cn(styles.contactRow, styles.topBar, {
            [styles.withBasketNoFavourites]: hasItemsInBasket && !hasFavourites,
            [styles.withFavouritesNoBasket]: !hasItemsInBasket && hasFavourites,
            [styles.noBasketNoFavourites]: !hasItemsInBasket && !hasFavourites
          })}
        >
          {helpCenterStatus ? <ContactButton contactSection={contactSection} /> : <ContactInfo />}
          <StoresInfo className={styles.stores} />
        </div>
        <Logo className={styles.logo} />
        {hasItemsInBasket && (
          <div className={styles.checkout}>
            <MobileBasket className={styles.basket} />
          </div>
        )}
      </header>
    </div>
  );
};

export default Header;
